export default "__VITE_ASSET__BOP6rbAt__"